export const FIRST_DIV = 1;
export const SECOND_DIV = 2;
export const THIRD_DIV = 3;
export const THROTTLE_TIME = 1000;
export const THROTTLE_TIME_SHORT = 700;
